import { Button, ButtonGroup, Grid, Paper } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import AlertDialog from "../../../components/alert-dialog/AlertDialog";
import { EditableHeading } from "../../../components/editable-heading/EditableHeading";
// Actions
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import { Loading } from "../../../components/loading/Loading";
import PageContainer from "../../../components/page-container/PageContainer";
import GenericPickerModal from "../../../containers/generic-picker-modal/GenericPickerModal";
import { addProductsToCategories, getCategoriesForIds, getCategory, getProductGroupsForCategory, removeCategories, removeProductsFromCategories, updateCategoryName } from "../../../state/actions/CategoryActions";
import { addEntitiesToProductGroup, getGroups, removeEntitiesFromProductGroup } from "../../../state/actions/GroupActions";
import { getProducts, getProductsForIds, IncludeType } from "../../../state/actions/ProductActions";
import { EntityType } from "../../../state/constants/EntityType";
import styles from "./ViewCategoryPage.module.scss";
import ListableCard from "../../../components/listable-card/ListableCard";
import { withTranslation } from "react-i18next";
import { SalesOrgIds } from "state/constants/SalesOrgIds";
import ProductPickerModal from "containers/generic-picker-modal/ProductPickerModal";

var categoryId = "";
let mode = Object.freeze({
  Product: 0,
  InclusiveProductGroup: 1,
  ExclusiveProductGroup: 2
});

class ViewCategoryPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingCategory: false,
      loadingProductGroupExclusions: false,
      loadingProductGroupInclusions: false,
      loadingProducts: false,
      productModalOpen: false,
      groupModalOpen: false,
      isEditing: false,
      productsToRemove: [],
      deleteCategoryAlertOpen: false,
      deleteProductAlertOpen: false,
      fetchingProducts: false,
      category: {},
      name: props.category.Name,
      groupPickerModalOpen: false,
      excludedFromProductGroups: [],
      includedInProductGroups: [],
    };
  }

  componentDidMount() {
    this.setState({ loadingCategory: true, loadingProducts: true, loadingProductGroupInclusions: true, loadingProductGroupExclusions: true, name: "" });

    categoryId = this.props.match.params.categoryId;

    this.props.getCategory(categoryId, () => {
      // Retrieve product details...
      const productIds = this.props.category.Products || [];

      this.setState({
        loadingCategory: false,
        name: this.props.category.Name,
        category: this.props.category
      });

      this.props.getProductsForIds(productIds, () => {
        this.setState({
          loadingProducts: false
        });
      });
    });

    this.props.getProductGroupsForCategory(
      categoryId,
      IncludeType.Include,
      () => {
        this.setState({
          loadingProductGroupInclusions: false
        });
      }
    );

    this.props.getProductGroupsForCategory(
      categoryId,
      IncludeType.Exclude,
      () => {
        this.setState({
          loadingProductGroupExclusions: false
        });
      }
    );
  }

  deleteCategoryAlert() {
    return (
      <AlertDialog
        title={this.props.t('common.remove-question')}
        description={this.props.t("common.remove-description")}
        options={[
          {
            label: this.props.t('common.cancel'),
            action: () => this.setState({ deleteCategoryAlertOpen: false })
          },
          {
            label: this.props.t('common.delete'),
            action: () => this.deleteCategory()
          }
        ]}
        isOpen={this.state.deleteCategoryAlertOpen}
      />
    );
  }

  componentDidUpdate() {

    if (
      JSON.stringify(this.state.category) !==
      JSON.stringify(this.props.category)
    ) {
      this.setState({
        category: this.props.category
      });
    }

    if (
      JSON.stringify(this.state.includedInProductGroups) !==
      JSON.stringify(this.props.includedInProductGroups)
    ) {
      this.setState({
        includedInProductGroups: this.props.includedInProductGroups
      });
    }

    if (
      JSON.stringify(this.state.excludedFromProductGroups) !==
      JSON.stringify(this.props.excludedFromProductGroups)
    ) {
      this.setState({
        excludedFromProductGroups: this.props.excludedFromProductGroups
      });
    }
  }

  deleteProductAlert() {
    return (
      <AlertDialog
        title={this.props.t('common.remove-question')}
        description={this.props.t("common.remove-description")}
        options={[
          {
            label: this.props.t('common.cancel'),
            action: () => this.setState({ deleteProductAlertOpen: false })
          },
          {
            label: this.props.t('common.delete'),
            action: () => this.handleDelete()
          }
        ]}
        isOpen={this.state.deleteProductAlertOpen}
      />
    );
  }

  deleteCategory() {
    this.props.removeCategories([categoryId], () => {
      this.props.history.push("/categories");
    });
  }

  handleDelete() {
    if (this.state.mode === mode.Product) {
      this.removeProductFromCategory();
    } else {
      this.removeProductGroups();
    }

    this.setState({ mode: "" });
  }

  removeProductGroups() {
    const isExcluded =
      this.state.mode === mode.InclusiveProductGroup ? false : true;

    this.props.removeEntitiesFromProductGroup(
      EntityType.CATEGORY,
      this.state.productGroupstoRemove,
      [categoryId],
      isExcluded,
      success => {
        if (success) {
          if (isExcluded) {
            this.props.getProductGroupsForCategory(
              categoryId,
              IncludeType.Exclude,
              () => { }
            );
          } else {
            this.props.getProductGroupsForCategory(
              categoryId,
              IncludeType.Include,
              () => { }
            );
          }
        }

        this.setState({ deleteProductAlertOpen: false });
      }
    );
  }

  removeProductFromCategory() {
    this.props.removeProductsFromCategories(
      this.state.productsToRemove,
      [categoryId],
      () => {
        this.setState({ deleteProductAlertOpen: false });
      }
    );
  }

  getProductDataForIds(productIds) {
    if (productIds !== undefined && productIds !== null) {
      return productIds.map(productId => {
        const product = this.props.products[productId];

        if (product !== undefined) {
          return { Name: product.ProductDisplayName != null ? product.ProductDisplayName : product.ProductName, id: product.id };
        }

        return {};
      });
    }

    return [];
  }

  handleProductGroupSelection(selected) {
    var shouldExclude = this.state.mode === mode.InclusiveProductGroup ? false : true;

    this.props.addEntitiesToProductGroup(
      EntityType.CATEGORY,
      selected,
      [categoryId],
      shouldExclude,
      success => {
        this.setState({
          groupPickerModalOpen: false,
        });

        if (success) {
          if (shouldExclude) {
            this.setState({ loadingProductGroupExclusions: true });

            this.props.getProductGroupsForCategory(
              categoryId,
              IncludeType.Exclude,
              () => {
                this.setState({ loadingProductGroupExclusions: false });
              }
            );
          } else {
            this.setState({ loadingProductGroupInclusions: true });

            this.props.getProductGroupsForCategory(
              categoryId,
              IncludeType.Include,
              () => {
                this.setState({ loadingProductGroupInclusions: false });
              }
            );
          }
        }
      }
    );
  }

  getContentGrid(assignedProducts) {
    const cards = [
      {
        add: this.props.t('category.assign-product'),
        buttonAction: () => {
          this.setState({
            mode: mode.Product,
            productModalOpen: true
          });
        },
        handleDelete: productsToRemove => {
          this.setState({
            mode: mode.Product,
            deleteProductAlertOpen: true,
            productsToRemove
          });
        },
        title: this.props.t('category.products-assigned'),
        emptyPlaceholder: this.props.t('category.no-products-assigned'),
        data: assignedProducts,
        isLoading: () => { return this.state.fetchingProducts }
      },
      {
        add: this.props.t('common.include'),
        buttonAction: () => {
          this.setState({
            groupPickerModalOpen: true,
            mode: mode.InclusiveProductGroup
          });
        },
        handleDelete: productGroupstoRemove => {
          this.setState({
            mode: mode.InclusiveProductGroup,
            deleteProductAlertOpen: true,
            productGroupstoRemove
          });
        },
        title: this.props.t('product.included-in-product-groups'),
        emptyPlaceholder: this.props.t('category.no-products-included'),
        data: this.state.includedInProductGroups,
        isLoading: () => { return this.state.loadingProductGroupInclusions }
      },
      {
        add: this.props.t('common.exclude'),
        buttonAction: () => {
          this.setState({
            groupPickerModalOpen: true,
            mode: mode.ExclusiveProductGroup
          });
        },
        handleDelete: productGroupstoRemove => {
          this.setState({
            mode: mode.ExclusiveProductGroup,
            deleteProductAlertOpen: true,
            productGroupstoRemove
          });
        },
        title: this.props.t('product.excluded-from-product-groups'),
        emptyPlaceholder: this.props.t('category.no-products-excluded'),
        data: this.state.excludedFromProductGroups,
        isLoading: () => { return this.state.loadingProductGroupExclusions }
      }
    ];

    return (
      <div className={styles.contentGrid}>
        <Grid container spacing={3}>
          {cards.map(card => {
            return (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Paper>
                  <ListableCard
                    actionButton={[
                      <Button
                        onClick={card.buttonAction}
                        variant="outlined"
                        color="secondary"
                      >
                        {card.add}
                      </Button>
                    ]}
                    isLoading={card.isLoading()}
                    addLabel={card.add}
                    title={card.title}
                    emptyPlaceholder={card.emptyPlaceholder}
                    handleDelete={card.handleDelete}
                    onClick={productId =>
                      this.props.history.push(`/products/${productId}`)
                    }
                    data={card.data == null ? [] : card.data}
                  />
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  }

  finishEditing() {
    if (this.state.changeOccurred) {
      this.props.updateCategoryName(categoryId, this.state.name, () => {
        console.log("Done saving...");
      });
    }

    this.setState({ isEditing: !this.state.isEditing, changeOccurred: false });
  }

  handleProductSelection(productIds) {
    this.props.addProductsToCategories(productIds, [categoryId], success => {
      this.setState({ productModalOpen: false, fetchingProducts: true });

      if (success) {
        // Go and fetch details for the added products...
        this.props.getProductsForIds(productIds, () => {
          setTimeout(() => {
            this.setState({ fetchingProducts: false });
          }, 1000);
        });
      }
    });
  }

  handleNameChange(value) {
    if (this.state.isEditing) {
      this.setState({ name: value, changeOccurred: true });
    }
  }

  getExcludedIds() {
    return this.state.excludedFromProductGroups.map((productGroup) => productGroup.id)
  }

  getIncludedIds() {
    return this.state.includedInProductGroups.map((productGroup) => productGroup.id)
  }

  render() {
    const assignedProducts = this.getProductDataForIds(
      this.props.category.Products
    );
    const content = this.getContentGrid(assignedProducts);
    const categoryProducts =
      this.props.category.Products !== null ? this.props.category.Products : [];

    if (this.state.loadingCategory) {
      return <Loading />;
    }

    return (
      <div>
        {this.deleteCategoryAlert()}
        {this.deleteProductAlert()}

        <ProductPickerModal
          handleProductSelection={selectedProducts => this.handleProductSelection(selectedProducts)}
          productModalOpen={this.state.productModalOpen}
          selected={categoryProducts}
          setProductModalOpen={() => this.setState({ productModalOpen: false })}
        />

        <GenericPickerModal
          handleCancel={() => this.setState({ groupPickerModalOpen: false })}
          handleDone={selectedProducts => this.handleProductGroupSelection(selectedProducts)}
          open={this.state.groupPickerModalOpen}
          selected={this.state.mode === mode.InclusiveProductGroup ? this.getIncludedIds() : this.getExcludedIds()}
          handleSelection={() => { }}
          getAllData={(callback) => this.props.getGroups(callback)}
          searchTitle={this.props.t('product-group.search')}
          title={this.props.t('product-group.product-groups')}
          data={Object.values(this.props.groups)}
          idField="id"
          valueField="Name"
        />

        <HeaderBlock
          title={
            <EditableHeading
              value={this.state.name}
              onChange={e => this.handleNameChange(e.target.value)}
            />
          }
          right={
            <Grid container spacing={2} alignItems="center" justify="flex-end">
              <Grid item>
                <ButtonGroup>
                  <Button
                    onClick={() =>
                      this.setState({ deleteCategoryAlertOpen: true })
                    }
                    variant="outlined"
                    disabled={!this.state.isEditing}
                    color="primary"
                  >
                    {this.props.t('common.delete')}
                  </Button>
                  <Button
                    onClick={() => this.finishEditing()}
                    variant="outlined"
                    color="secondary"
                  >
                    {this.state.isEditing ? this.props.t('common.done') : this.props.t('common.edit')}
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          }
        />
        <PageContainer>
          {content}
        </PageContainer>
      </div>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const {
    category,
    includedInProductGroups,
    excludedFromProductGroups
  } = state.CategoryReducer;
  const { products } = state.ProductReducer;
  const { groups } = state.GroupReducer
  return {
    category,
    products,
    includedInProductGroups,
    excludedFromProductGroups,
    groups
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getCategory,
      removeCategories,
      addProductsToCategories,
      removeProductsFromCategories,
      getProductsForIds,
      updateCategoryName,
      getCategoriesForIds,
      addEntitiesToProductGroup,
      getProductGroupsForCategory,
      removeEntitiesFromProductGroup,
      getProducts,
      getGroups
    },
    dispatch
  );

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ViewCategoryPage))
);

// EXPORT COMPONENT

export { hoc as ViewCategoryPage };

